import { Config } from 'modules/config/state/config-types'
import { URLParams } from 'modules/url-params/state/app-url-params-types'
import { OrderCurrencySlice } from './order-currency-types'
import { getCurrencySymbol } from 'utils/functions/currencyUtils'

export const DEFAULT_CURRENCY = 'USD'

export const makeOrderCurrencyInitialState = (
  config: Config,
  urlParams: URLParams,
): OrderCurrencySlice => {
  const value = urlParams.currency || config.currency.default || DEFAULT_CURRENCY
  const symbol = getCurrencySymbol(value) || value

  return {
    value,
    exchangeRate: 1,
    symbol: symbol,
    loading: false,
    error: null,
  }
}
